import { store } from "..";
import { setFilterDBData } from "../store/reducers/overall.slice";
import { getCardPatientChartData, getAllOverallCount } from "./api/overall.api";
import {
	setFilterDBData as setFilterDBDataComparison,
	setCardFilterOverall,
} from "../store/reducers/comparisonReducers/overallComparison.slice";


const ongoingOverallRequestsChart = new Map();

const cardPatientAndChartData = async (data = null, type) => {
	const requestKey = JSON.stringify({ type });

	// Check for duplicate requests
	if (ongoingOverallRequestsChart.has(requestKey)) {
		const { controller } = ongoingOverallRequestsChart.get(requestKey);
		controller.abort(); // Abort the ongoing request
		ongoingOverallRequestsChart.delete(requestKey); // Clean up the old request
	}

	const controller = new AbortController();
	const signal = controller.signal;
	try {
		const requestPromise = getCardPatientChartData(data, { signal });
		ongoingOverallRequestsChart.set(requestKey, { requestPromise, controller });

		const res = await requestPromise;
		return res;
	} catch (e) {
		console.log(e);
		if (e.name === "AbortError") {
			console.log("Request aborted:", requestKey);
		} else {
			console.log(e);
			throw e; // Rethrow other errors
		}
		// throw e; // Rethrow the error if needed
	} finally {
		// Cleanup: Remove the request from tracking once it completes
		ongoingOverallRequestsChart.delete(requestKey);
	}
};

const ongoingOverallRequests = new Map();

/**
 * Fetches Overall patient counts/list from the API. In-flight dedupe uses a composite key so parallel
 * calls with different intent do not abort each other (e.g. Trend Mapping Overall Incoming vs Outgoing).
 *
 * @param {object|null} data - Request params (expects startDate, endDate, facilityIds when applicable).
 * @param {boolean} [forComparison] - When true, writes comparison Redux; when false/undefined, main Overall slice.
 * @param {string} [type] - Optional logical scope for dedupe only (`"main"`, `"comparison"`, `overallIncoming`, …).
 *   Omitted callers use `"default"` plus dates/facilities in the key — same as before for single-flight dedupe.
 */
const getAllOverallPatient = async (data = null, forComparison, type) => {
	// Composite key: same filter + same forComparison + same type still dedupes; different type/dates/facilities do not.
	const requestKey = JSON.stringify({
		type: type ?? "default",
		sd: data?.startDate ?? "",
		ed: data?.endDate ?? "",
		fc: Boolean(forComparison),
		fi: Array.isArray(data?.facilityIds) ? data.facilityIds.join(",") : "",
	});

	// Check for duplicate requests
	if (ongoingOverallRequests.has(requestKey)) {
		const { controller } = ongoingOverallRequests.get(requestKey);
		controller.abort(); // Abort the ongoing request
		ongoingOverallRequests.delete(requestKey); // Clean up the old request
	}

	const controller = new AbortController();
	const signal = controller.signal;

	try {

		const requestPromise = getAllOverallCount(data, { signal });
		ongoingOverallRequests.set(requestKey, { requestPromise, controller });

		const res = await requestPromise;

		if (res && forComparison) {
			store.dispatch(setCardFilterOverall({ listData: res }));
		}
		store.dispatch(forComparison ? setFilterDBDataComparison(res.totals) : setFilterDBData(res.totals));

		return res.data;
	} catch (e) {
		if (e.name === "AbortError") {
			console.log("Request aborted:", requestKey);
		} else {
			throw e; // Rethrow other errors
		}
		// throw e; // Rethrow the error if needed
	} finally {
		// Cleanup: Remove the request from tracking once it completes
		ongoingOverallRequests.delete(requestKey);
	}
};

// const getAllOverallPatient = async (data = null, forComparison) => {
// 	try {
// 		const res = await getAllOverallCount(data);
// 		if (res && forComparison) {
// 			store.dispatch(setCardFilterOverall({ listData: res }));
// 		}
// 		store.dispatch(forComparison ? setFilterDBDataComparison(res.totals) : setFilterDBData(res.totals));
// 		return res.data;
// 	} catch (e) {}
// };

export { cardPatientAndChartData, getAllOverallPatient };
